import {DataGrid, GridColDef} from "@mui/x-data-grid";
import React from "react";
import {useTranslation} from "react-i18next";
import {Device, DeviceFlat} from "../../../app/api/model/device";
import {EMPTY_UI} from "../../../variables";

interface CompactDeviceListProps {
    devices?: Device[] | DeviceFlat[];
}

export default function CompactDeviceList({devices}: CompactDeviceListProps) {
    const {t} = useTranslation();

    const deviceTableColumns: GridColDef[] = [
        {field: "iccid", headerName: t("generic_iccid"), width: 200},
        {field: "msisdn", headerName: t("device_msisdn"), width: 150},
        {field: "imsi", headerName: t("device_imsi"), width: 150},
        {field: "imei", headerName: t("device_imei"), width: 150},
        {field: "licensePlate", headerName: t("device_licensePlate"), width: 150},
        {field: "hardwareType", headerName: t("device_hardwareType"), width: 125},
    ];

    return (
        <div style={{height: 350, width: "100%"}}>
            <DataGrid
                columns={deviceTableColumns.map((c) => ({
                    ...c,
                    valueFormatter: (p) => p.value || EMPTY_UI,
                }))}
                rows={devices || []}
                rowHeight={25}
                headerHeight={25}
                hideFooter
            />
        </div>
    );
}
